import React, {useContext, useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {ActionPanelContextProvider} from "context/action";
import {ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE} from "./context/AssetTransferContext";
import {SecurityContext} from "context/security";
import AssetTransferListPanel from "./AssetTransferListPanel";
import AssetTransferActivitiesPanel from "./AssetTransferActivitiesPanel";
import {AssetTransferContext} from "./context";

export default function AssetTransferPanel() {

    const {assetTransferCaptureDisplayState,clearAssetTransferSearchAndLoadHome} = useContext(AssetTransferContext);
    const {resetFlagRight} = useContext(SecurityContext);

    if(resetFlagRight.current){
        resetFlagRight.current = false;
        clearAssetTransferSearchAndLoadHome();
    }

    const currentComponent = function () {

        if (assetTransferCaptureDisplayState && assetTransferCaptureDisplayState.currentPage === ASSET_TRANSFER_CAPTURE_PANEL_ACTIVITIES_PAGE) {
            return <AssetTransferActivitiesPanel/>
        }
        else {
            return <AssetTransferListPanel/>
        }

    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {currentComponent()}
                </Col>
            </Row>
            <Row>
                <br/>
            </Row>
        </Container>
    </>);

}
